// Main  actions are grouped around the contextual panel
// these tend to related to key entities in the system
export enum ActionGroupings {
   LoadAllCallersWithoutMapPoints,
   LoadVisitsForCaller,
   LoadCallpointsForCaller,
   LoadDiaryEvents
 }
